// Get the button
const mybutton:HTMLElement | null = document.getElementById("btn-back-to-top");
const p2Element: HTMLElement | null = document.getElementById("p2");

if (mybutton)
{
  // When the user scrolls down 20px from the top of the document, show the button

  const scrollFunction = () => {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      mybutton.classList.remove("hidden");
    } else {
      mybutton.classList.add("hidden");
    }
  };
  const backToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // When the user clicks on the button, scroll to the top of the document
  mybutton.addEventListener("click", backToTop);
  window.addEventListener("scroll", scrollFunction);
}


if (p2Element)
{
  const isMobile: boolean = p2Element.getAttribute("isMobile") == "1"? true : false;

  const scrollFunction = () => {
    if (p2Element.getAttribute("state") == "close")
    {
      return;
    }
    
    if (
      document.body.scrollTop > 600 ||
      document.documentElement.scrollTop > 600
    ) {
      p2Element.classList.remove("hidden");
      p2Element.setAttribute("state", "open");

      if (isMobile) mybutton!.style.transform = "translate(0, -140px)";  ;
    }

    const button = p2Element.querySelector("button");

    button?.addEventListener("click", () =>
    {
      p2Element.classList.add("hidden");
      p2Element.setAttribute("state", "close");
      mybutton!.style.transform = "translate(0, 0px)";
    });
  };

  window.addEventListener("scroll", scrollFunction);
}